export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/2cb37da391587709fd85749e116baa74.svg";